// Pricing shown on every brand demo (Sonic Prospect for Appointments, 2026-10-25): the same terms as
// pivony.com/plans and the Sonic Prospect Fees Policy.
export const OFFER = {
  label: "Pricing",
  priceLine: "Your first 5 new customers are free",
  subline: "Then $4.99 per new customer who books.",
  definition:
    "A New Customer Booking is a new customer's first appointment booked through Sonic, billed only after the appointment time passes without a cancellation. Existing customers who book again, cancellations and no-shows are free.",
  note: "You pay when a new customer books, not for chats.",
};

export const PRODUCT_URL = "https://pivony.com/products/sonic-prospect";
export const BRAND = "/assets/sonic-demo";

export function campaignUrl(base, slug, medium = "pricing") {
  const query = `utm_source=demo&utm_medium=${medium}&utm_campaign=${encodeURIComponent(slug || "")}`;
  if (base.includes("#")) {
    const [root, fragment] = base.split("#");
    return `${root}?${query}#${fragment}`;
  }
  return `${base}?${query}`;
}

export function sourceLabel(url) {
  try {
    const parsed = new URL(url);
    return parsed.host.replace(/^www\./, "") + parsed.pathname.replace(/\/$/, "");
  } catch (error) {
    return url;
  }
}
